import type { RouteRecordRaw } from "vue-router";
import examManagementRoutes from "./back/examManagement";
import mockExamManagementRoutes from "./back/mockExamManagement";
import schoolManagementRoutes from "./back/schoolManagement";
import areaManagementRoutes from "./back/areaManagement";
import teacherManagementRoutes from "./back/teacherManagement";
import dataAnalysisRoutes from "./back/dataAnalysis";
import testRoutes from "./back/test";
import aiClassRoomRoutes from "./back/aiClassRoom";
import systemRoutes from "./back/system";
import officeRoutes from "./office/index";

const moduleRoutes: RouteRecordRaw[] = [
  examManagementRoutes,
  mockExamManagementRoutes,
  areaManagementRoutes,
  schoolManagementRoutes,
  teacherManagementRoutes,
  ...dataAnalysisRoutes,
  testRoutes,
  aiClassRoomRoutes,
  systemRoutes,
  officeRoutes,
];

export default moduleRoutes;
